import React, { useContext, useState, useEffect } from 'react'
import { Button } from 'grommet'

import { AuthContext } from '../Firebase/Auth'

const ScraperForm = () => {
  const [url, setUrl] = useState()
  const { currentUser } = useContext(AuthContext)
  const urlRef = React.createRef()

  useEffect(() => {
    setUrl(urlRef.current.value)
  }, [urlRef])

  const request = () => {
    const userID = currentUser.uid
    if (url.includes('https://www.hemnet.se/bostad/')) {
      const cleanURL = url.replace('https://www.hemnet.se/bostad/', '')
      window.open(
        `http://13.48.44.36:3001/scraper/${cleanURL}_userID=${userID}`
      )
    } else {
      setUrl('')
    }
  }

  return (
    <form>
      <input
        type="url"
        value={url}
        required
        ref={urlRef}
        placeholder="Enter Hemnet Link"
        onChange={() => setUrl(urlRef.value)}
        style={{
          background: '#f1f1f1',
          border: '0',
          padding: '10px 20px',
          borderRadius: '80px 0 0 80px',
          minWidth: '70%',
          outline: 'none'
        }}
      />
      <Button
        label="Import"
        onClick={request}
        style={{
          marginLeft: '-20px',
          paddingTop: '5px',
          paddingBottom: '6px',
          backgroundColor: '#fff'
        }}
      />
    </form>
  )
}

export default ScraperForm
